import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=0a85b89e&scoped=true&"
import script from "./DialogContent.vue?vue&type=script&lang=js&"
export * from "./DialogContent.vue?vue&type=script&lang=js&"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=0a85b89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85b89e",
  null
  
)

export default component.exports